import { useDocumentStore } from "@/stores/documents";
import { useTilesStore } from "@/stores/tiles";

let startPrefetch, stopPrefetch;

export default {
  bind(el, binding, vnode) {
    let timeOutInstance = null;
    let isFetchingDone = false;

    const prefetch = async () => {
      if (!isFetchingDone && binding.value.url) {
        try {
          const actionFlow = urlToActionMap[binding.value.url];
          isFetchingDone = true;
          let payload;
          if (actionFlow) {
            for (const act of actionFlow) {
              // Fill in payload
              if (act.parameters) {
                payload = Object.assign(act.parameters);
                const keys = Object.keys(payload);
                keys.forEach(key => {
                  if (binding.value[key]) {
                    payload[key] = binding.value[key];
                  }
                });
              }

              // Dispatch action
              if (act.type === "vuex") {
                await vnode.context.$store.dispatch(act.action, payload);
              }
              if (act.type === "useDocumentStore") {
                const documentStore = useDocumentStore();
                await documentStore[act.function](vnode.context.$store);
              }
              if (act.type === "useTilesStore") {
                const tilesStore = useTilesStore();
                await tilesStore[act.function](vnode.context.$store);
              }
            }
          }
          // eslint-disable-next-line no-empty
        } catch {} // Its okay to fail here - it's just a prefetch
      }
    };

    startPrefetch = async () => {
      if (!timeOutInstance) {
        timeOutInstance = setTimeout(async () => {
          await prefetch();
          timeOutInstance = null;
        }, 100);
      }
    };

    stopPrefetch = async () => {
      clearTimeout(timeOutInstance);
      timeOutInstance = null;
    };

    if (binding && binding.value.url && urlToActionMap[binding.value.url]) {
      el.addEventListener("mouseenter", startPrefetch, true);
      el.addEventListener("mouseleave", stopPrefetch, true);
    }
  },

  unbind(el) {
    el.removeEventListener("mouseenter", startPrefetch, true);
    el.addEventListener("mouseleave", stopPrefetch, true);
  }
};

const urlToActionMap = {
  sectionDocuments: [
    { type: "vuex", action: "sections/loadDrives", parameters: { sectionId: "", forceReload: false } },
    { type: "vuex", action: "documents/loadSectionDrivesRoot", parameters: { sectionId: "" } }
  ],
  "/sections": [
    { type: "useSectionStore", action: "loadMySections" },
    { type: "useTilesStore", action: "loadTilesForMySections", parameters: {} }
  ],
  sectionAssignments: [
    { type: "vuex", action: "assignments/loadForSection", parameters: { extSysApiSectionId: "", sectionId: "" } }
  ],
  "/mydocuments": [
    { type: "vuex", action: "documents/loadDrive" },
    { type: "useDocumentStore", function: "loadMyOneDriveRoot" }
  ]
};
